<template>
    <div inis-transition-group>
        <header v-if="contentIsLoaded">
            <!-- <div class="height-fake"></div> -->
            <HeroTexteBlocVideoSticky />
        </header>

        <main class="page-content" tabindex="-1">
            <section v-if="contentIsLoaded" class="home-cta bg-img">
                <h2
                    class="text-stencil-wrapper"

                >
                    <div class="container-xxl">
                        <div class="row justify-content-center">
                            <div class="col-12 col-lg-10">
                                <div>
                                    <h2
                                     class="stencil-title">{{ $t('Découvrez') }}</h2>
                                </div>
                                <!-- Removed small button text commit nov.17th 2022 -->
                                <div class="text d-flex flex-row">
                                    <h2
                                     class="stencil-title">{{ $t('nos') }}</h2>
                                    <div class="d-flex align-items-end flex-column ms-5">
                                        <div class="mt-auto d-none d-xxl-block">
                                            <div class="mb-0 me-auto mt-auto lh-1">
                                                <p class="text-stencil-button mb-3">
                                                    {{$t('Par quel chemin désirez-vous découvrir nos formations?')}}
                                                </p>
                                            </div>
                                            <div class="button-stencil-wrapper mb-4">
                                                <a class="button secondary btn-stencil" @click.prevent="setSidebarMainStep('creation')">
                                                    <span class="text-big">
                                                        {{$t('Domaines de création')}}
                                                    </span>
                                                </a>
                                                <a class="button secondary btn-stencil" @click.prevent="setSidebarMainStep('jobs')">
                                                    <span class="text-big">
                                                        {{$t('Métiers')}}
                                                    </span>
                                                </a>
                                                <a class="button secondary btn-stencil position-top" @click.prevent="setSidebarMainStep('organisationsProfessionnelles')">
                                                    <span class="text-big">{{$t('Organisations')}}</span>
                                                    <span class="text-big">{{$t('professionnelles')}}</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <h2
                                     class="stencil-title">{{ $t('formations') }}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </h2>
                <div class="container-xxl d-xxl-none mt-4">
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-10">
                            <div class="mb-0 me-auto mt-auto lh-1">
                                <p>
                                    {{ $t('Par quel chemin désirez-vous découvrir nos formations?') }}
                                </p>
                            </div>
                            <div>
                                <a class="button secondary btn-stencil mb-4 me-md-4" @click.prevent="setSidebarMainStep('creation')">
                                    <span class="text-big">{{ $t('Domaines de création') }}</span>
                                </a>
                                <a class="button secondary btn-stencil mb-4 me-md-4" @click.prevent="setSidebarMainStep('jobs')">
                                    <span class="text-big">{{ $t('Métiers') }}</span>
                                </a>
                                <a class="button secondary btn-stencil mb-4 position-top" @click.prevent="setSidebarMainStep('organisationsProfessionnelles')">
                                    <span class="text-big">{{$t('Organisations')}}</span>
                                    <span class="text-big">{{$t('professionnelles')}}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section
                v-if="contentIsLoaded && content.presentation.text !== null"
                class="back-col-white"
            >
                <div class="container-xxl home-about">
                    <div class="row">
                        <div class="col-12 col-lg-10 offset-lg-1 col-xl-8">
                            <h6 class="mb-5 text-uppercase text-weight-medium" v-html="content.presentation.sectionTitle"></h6>
                            <h3 class="mb-5 text-weight-medium">
                                {{ content.presentation.text }}
                            </h3>
                            <router-link
                                v-if="content.presentation.sectionLink.fr"
                                class="button"
                                :to="{ path: content.presentation.sectionLink.fr }"
                                itemtype="https://www.schema.org/SiteNavigationElement"
                            >
                                {{ content.presentation.customText }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </section>

            <section
                v-if="pageIsLoaded"
                class="home-community back-col-black bg-repeat"
            >
                <div class="container-xxl d-md-none">
                    <SwiperTeam v-if="content.team" :team="content.team" />
                </div>

                <div class="container-xxl d-none d-md-block">
                    <div class="row">
                        <div class="col-8 col-lg-10 offset-lg-1">
                            <h6 class="text-white text-uppercase mb-4 mb-lg-5">
                                {{ content.teamStatic.SectionTitleTeam }}
                            </h6>
                            <h4 class="text-toggle-wrapper text-white d-lg-none mb-5">
                                <span
                                    class="text-toggle"
                                    :class="{ isactive: currentImage.text == content.team[0].text }"
                                    >{{ content.team[0].text }}</span
                                >
                                <span
                                    class="text-toggle"
                                    :class="{ isactive: currentImage.text == content.team[1].text }"
                                    >{{ content.team[1].text }}</span
                                >
                                <span
                                    class="text-toggle"
                                    :class="{ isactive: currentImage.text == content.team[2].text }"
                                    >{{ content.team[2].text }}</span
                                >
                            </h4>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4 col-lg-3 offset-lg-1">
                            <div
                                class="img-left bg-img"
                                :style="{ backgroundImage: `url(${content.team[0].img.url})` }"
                                @mouseenter="toggleText(content.team[0])"
                            ></div>
                        </div>
                        <div class="col-8 col-lg-7">
                            <div class="row">
                                <div class="col-7 col-lg-6">
                                    <div
                                        class="img-right marging bg-img"
                                        :style="{
                                            backgroundImage: `url(${content.team[1].img.url})`,
                                        }"
                                        @mouseenter="toggleText(content.team[1])"
                                    ></div>
                                </div>
                                <div class="col-5 offset-1 d-none d-lg-block">
                                    <h4 class="text-toggle-wrapper text-white textanimation">
                                        <span
                                            class="text-toggle"
                                            :class="{
                                                isactive: currentImage.text == content.team[0].text,
                                            }"
                                            >{{ content.team[0].text }}</span
                                        >
                                        <span
                                            class="text-toggle"
                                            :class="{
                                                isactive: currentImage.text == content.team[1].text,
                                            }"
                                            >{{ content.team[1].text }}</span
                                        >
                                        <span
                                            class="text-toggle"
                                            :class="{
                                                isactive: currentImage.text == content.team[2].text,
                                            }"
                                            >{{ content.team[2].text }}</span
                                        >
                                    </h4>
                                </div>

                                <div class="col-12 col-lg-10">
                                    <div
                                        class="img-right bg-img"
                                        :style="{
                                            backgroundImage: `url(${content.team[2].img.url})`,
                                        }"
                                        @mouseenter="toggleText(content.team[2])"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="home-actuality">
                <div class="section-top">
                    <div class="section-left">
                        <div class="latest-news-wrapper">
                            <div class="news-header pb-4">
                                <div>
                                    <h6>{{ $t('PROCHAINES FORMATIONS') }}</h6>
                                </div>
                                <div>
                                    <router-link
                                        class="bold text-red link-arrow right"
                                        :to="{ path: 'calendrier' }"
                                        itemtype="https://www.schema.org/SiteNavigationElement"
                                    >
                                        {{ $t('VOIR LE CALENDRIER') }}
                                    </router-link>
                                </div>
                            </div>

                            <div v-if="latestsFormationsIsLoaded">
                                <router-link
                                    v-for="(formation, index) in orderedFormation"
                                    :key="'formation-' + index"
                                    class="news"
                                    :to="{ path: '/formation/' + formation.slug }"
                                    itemtype="https://www.schema.org/SiteNavigationElement"
                                >
                                    <div class="news-exerpt">
                                        <div class="mb-2">
                                            <FormationStatusLabel :item="formation" />
                                        </div>
                                        <div class="mb-4">
                                            <h5 class="mb-0">{{ formation.title }}</h5>
                                        </div>

                                        <div>
                                            <span class="bold text-red link-arrow right">{{$t('Voir plus')}}</span>
                                        </div>
                                    </div>
                                    <div v-if="formation.startDate == 'null'" class="news-date">
                                        <span class="month">{{ $t(' À venir') }}</span>
                                    </div>
                                    <div v-else class="news-date">
                                        <span class="day mb-2">{{
                                            thePostDay(formation.startDate)
                                        }}</span>
                                        <span class="month">{{
                                            thePostMonth(formation.startDate)
                                        }}</span>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="section-right">
                        <div v-if="featuredProductionIsLoaded">
                            <div class="cards-news-highlight dark">
                                <BGAssetLoader
                                    v-if="featuredProduction.imageId !== 0"
                                    :asset="{ asset: featuredProduction.imageId }"
                                    class="img-back bg-img"
                                />
                                <div class="overlay-dark-soft"></div>

                                <div class="card-header">
                                    <div>
                                        <h6 class="mb-2 mb-sm-0 text-uppercase">{{ $t('Projets étudiants') }}</h6>
                                    </div>
                                    <div>


                                        <router-link
                                            class="bold link-arrow right"
                                            :to="{ path: '/projets-etudiants' }"
                                            itemtype="https://www.schema.org/SiteNavigationElement"
                                        >
                                            {{$t('Voir plus')}}
                                        </router-link>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="mt-auto">
                                        <p class="subtitle">
                                            {{
                                                featuredProduction.format +
                                                ' - ' +
                                                featuredProduction.description
                                            }}
                                        </p>
                                        <router-link
                                            class=""
                                            :to="{ path: '/projets-etudiants/' + featuredProduction.slug }"
                                            itemtype="https://www.schema.org/SiteNavigationElement"
                                        >
                                            <h4 class="mb-0 title">{{ featuredProduction.title }}</h4>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="contentIsLoaded && content.latestNews"
                            class="cards-news-highlight back-col-yellow"
                        >
                            <div class="card-header">
                                <div>
                                    <h6 class="mb-2 mb-sm-0 text-uppercase">{{ $t('Nouvelles') }}</h6>
                                </div>
                                <div>
                                    <router-link
                                        class="bold text-red link-arrow right"
                                        :to="{ path: '/nouvelles' }"
                                        itemtype="https://www.schema.org/SiteNavigationElement"
                                    >
                                        {{$t('Voir plus')}}
                                    </router-link>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="mt-auto">
                                    <p class="date">
                                        {{ thePostDate(content.latestNews[0].postDate.date) }}
                                    </p>

                                    <router-link
                                        :to="{ path: content.latestNews[0].jsonUrl }"
                                        itemtype="https://www.schema.org/SiteNavigationElement"
                                    >
                                        <h4 class="mb-0 title" v-html="content.latestNews[0].title "></h4>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="pageIsLoaded && content.testimonialsHighlight.img.url !== ''"
                    class="section-bottom"
                    :style="{ backgroundImage: `url(${content.testimonialsHighlight.img.url})` }"
                >
                    <div class="container-xxl">
                        <div class="row pb-1 pb-md-5 mb-5">
                            <div class="col-auto">
                                <blockquote class="display mx-auto max-quote" v-html="content.testimonialsHighlight.testimonialMain">
                                </blockquote>
                            </div>
                        </div>

                        <div
                            v-if="globals.globalTestimonials.testimonials.elements"
                            class="row justify-content-center gx-5 pt-5"
                        >
                            <div
                                v-for="(value, index) in shuffleArray(
                                    globals.globalTestimonials.testimonials.elements
                                )"
                                :key="'testimonial-' + index"
                                class="col-12 col-lg-4 col-xx mb-5"
                            >
                                <blockquote class="medium text-white mb-5">
                                    {{ value.testimonial }}
                                </blockquote>
                                <div class="credit-director">
                                    <div>
                                        <div
                                            class="director-img bg-img"
                                            :style="{
                                                backgroundImage: `url(${value.personImg.url})`,
                                            }"
                                        ></div>
                                    </div>
                                    <div class="director-text text-white">
                                        <h6 class="mb-2">{{ value.personName }}</h6>
                                        <p class="role text-white">{{ value.personRole }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters, mapActions } from 'vuex'
import { getFeaturedItem, getLatestDocs } from '@/firebase/init'
import dayjs from 'dayjs'
var customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

import HeroTexteBlocVideoSticky from '@/components/hero/HeroTexteBlocVideoSticky'
import SwiperTeam from '@/components/swiper/SwiperTeam'
import BGAssetLoader from '@/components/helpers/BGAssetLoader'
import FormationStatusLabel from '@/components/Parts/FormationStatusLabel'

export default {
    name: 'Home',

    data() {
        return {
            featuredProduction: null,
            featuredProductionIsLoaded: false,
            latestsFormations: [],
            latestsFormationsIsLoaded: false,
            firestoreErr: null,
            currentImage: null,
        }
    },

    components: {
        HeroTexteBlocVideoSticky,
        SwiperTeam,
        BGAssetLoader,
        FormationStatusLabel,
    },

    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    this.currentImage = this.content.team[0]
                    try {
                        this.latestsFormations = await getLatestDocs()
                        this.latestsFormationsIsLoaded = true

                        const res = await getFeaturedItem()
                        this.featuredProduction = res
                        this.featuredProductionIsLoaded = true
                    } catch (e) {
                        this.firestoreErr = e
                    }
                }
            },
            immediate: true,
        },
    },

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
        orderedFormation() {
            if(!this.latestsFormations) {
                return []
            }
            const formationList = [...this.latestsFormations]
            const filteredarray = []

            formationList.forEach((element) => {
                if(element.lms !== 'undefined' && element.lms !== true){
                    element.orderArray = new Date(element.startDate)
                    filteredarray.push(element)
                }
            });

            return filteredarray.sort((a, b) => {
                return a.orderArray - b.orderArray
            }).splice(0, 4)

        },
    },
    methods: {
        toggleText(image) {
            this.currentImage = image
        },
        shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1))
                ;[array[i], array[j]] = [array[j], array[i]]
            }
            return array.slice(0, 3)
        },
        thePostDate(actualDate) {
            var date = new Date(actualDate)
            return dayjs(date).format('D MMMM YYYY')
        },
        thePostDay(actualDate) {
            var date = dayjs(actualDate, "YYYY-MM-DD")
            return dayjs(date).format('D')
        },
        thePostMonth(actualDate) {
            var date = dayjs(actualDate, "YYYY-MM-DD")
            return dayjs(date).format('MMMM')
        },
        ...mapActions(['setSidebarMainStep']),
    },
}
</script>
